import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { connectFirestoreEmulator, enableIndexedDbPersistence, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectAuthEmulator, EmailAuthProvider, getAuth, GoogleAuthProvider, TwitterAuthProvider } from 'firebase/auth'
import * as firebaseui from 'firebaseui'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'
import { getPerformance } from 'firebase/performance'
import { functionsRegion } from '@geartrack/shared-lib/dist/firebase'

export const firebaseConfig = {
  apiKey: 'AIzaSyCoL8jjc4CRUA-uI9uMlScqKezrkYmyUQo',
  authDomain: 'geartrack-243919.firebaseapp.com',
  projectId: 'geartrack-243919',
  storageBucket: 'geartrack-243919.appspot.com',
  messagingSenderId: '190374997477',
  appId: '1:190374997477:web:7acddd81aafd998271d30c',
  measurementId: 'G-N4WQXGZNKE',
}

export const firebaseUIConfig: firebaseui.auth.Config = {
  signInFlow: 'redirect',
  signInSuccessUrl: '/login/complete', // will sync the local packages with the remote
  signInOptions: [
    GoogleAuthProvider.PROVIDER_ID,
    // FacebookAuthProvider.PROVIDER_ID,
    EmailAuthProvider.PROVIDER_ID,
    // GithubAuthProvider.PROVIDER_ID,
    TwitterAuthProvider.PROVIDER_ID,
  ],
  tosUrl: '/terms-and-conditions',
  privacyPolicyUrl: '/privacy-policy',
}

// Initialize Firebase
export const firebaseInstance = initializeApp(firebaseConfig)

export const firestoreInstance = getFirestore(firebaseInstance)
export const authInstance = getAuth(firebaseInstance)
export const functionsInstance = getFunctions(firebaseInstance, functionsRegion)
export const analyticsInstance = getAnalytics(firebaseInstance)
export const perfInstance = getPerformance(firebaseInstance)

if (process.env.REACT_APP_FIREBASE_EMULATORS) {
  // @ts-ignore
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_FIREBASE_APP_CHECK_DEBUG_TOKEN
  connectFirestoreEmulator(firestoreInstance, 'localhost', 8080)
  connectAuthEmulator(authInstance, 'http://localhost:9099')
  connectFunctionsEmulator(functionsInstance, 'localhost', 5001)
}

// cache data in indexdb (offline functionality)
enableIndexedDbPersistence(getFirestore(firebaseInstance)).catch(err => {
  if (err.code === 'failed-precondition') {
    console.error('Multiple tabs open, persistence can only be enabled in one tab at a time.', err)
  } else if (err.code === 'unimplemented') {
    console.error('The current browser does not support all of the features required to enable persistence', err)
  }
})

// needs to be after self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
export const appCheckInstance = initializeAppCheck(firebaseInstance, {
  provider: new ReCaptchaV3Provider('6Lc0hDchAAAAAKA8TKm6XniMxGRksmN-mZJBCIg_'),
  isTokenAutoRefreshEnabled: true,
})
